export default [
  {
    path: "visitors",
    name: "frontend.reporting.visitors",
    component: () => import(/* webpackChunkName: "Website" */ './Website'),
    meta: {
      headline: () => $t("navigation.statistics.visitors"),
      description: () => $t("topBar.descriptions.reporting.visitors"),
      tracking: "Visitors - Page view - Main page",
      datepicker: true
    }
  }
];
